import AttorneyClaimants from "./AttorneyClaimants";

export default AttorneyClaimants;